import styled, { css } from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

export const PopoverWrapper = styled.div`
  .ant-popover-content {
    border-radius: 8px !important;
    overflow: hidden !important;
  }
`;

/** 카드(컨테이너) */
export const GridCard = styled.div`
  display: inline-block;
  background: ${COLORS.WHITE};
`;

/** 그리드(컬럼만 바꿔 끼우기) */
export const GridLayout = styled.div<{ $columns: string }>`
  display: grid;
  grid-template-columns: ${(props) => props.$columns};
  font-size: ${calcRem(13)};
`;

/** 셀 공통(바디/헤더가 같이 씀) */
const cellBase = css`
  padding: 8px;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #eeeeee;
  background: ${COLORS.WHITE};

  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const GridCell = styled.div<{
  $align?: "left" | "center" | "right";
  $colSpan?: number;
  $rowSpan?: number;
  $noRightBorder?: boolean;
}>`
  ${cellBase}

  ${(p) =>
    p.$align === "center" &&
    css`
      justify-content: center;
    `}

  ${(p) =>
    p.$align === "right" &&
    css`
      justify-content: flex-end;
    `}

  ${(p) =>
    p.$colSpan &&
    css`
      grid-column: span ${p.$colSpan};
    `}

  ${(p) =>
    p.$rowSpan &&
    css`
      grid-row: span ${p.$rowSpan};
    `}

  ${(p) =>
    p.$noRightBorder &&
    css`
      border-right: 0;
    `}
`;

export const GridHeaderCell = styled(GridCell)`
  font-weight: 700;
  border-bottom: 1px solid #e2e2e2;
`;
